<template>
    <div class="container mt-3">
        <div class="new-create">
            <div class="row">
                <div class="col-md-12 new-background mb-5">

                    <h1 class="mb-4 mt-4 new-heading" v-if="!testi">Update Testimonials</h1>
                    <h1 class="mb-4 mt-4 new-heading" v-if="testi">Add Testimonials</h1>

                    <form>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>User ID</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter User ID"
                                           v-model="testiAdd.user_id" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>User Type</b></label>
                                    <select class="form-control" v-model="testiAdd.user_type" required>
                                        <option value="1">Student</option>
                                        <option value="2">Company</option>
                                        <option value="3">Employee</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label><b>Testimonial Description</b></label>
                            <editor v-model="testiAdd.testimonial" v-validate="'required|min:16'"
                                    name="testimonial"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="news description"></editor>
                            <small v-if="errors.has('testimonial')" class="text-danger">
                                {{ errors.first('testimonial') }}
                            </small>
                        </div>


                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!testi"
                                    @click="update_testimonial()">UPDATE
                            </button>
                            <button type="button" class="btn btn-primary" v-if="testi" @click="add_testimonial()">ADD
                            </button>
                            <router-link :to="{name: 'website-testimonials'}" class="btn my-4 btn-seondary">
                                Back
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import _ from "lodash";

export default {
  name: "CreateTestimonials",
  components: { Editor },
  data() {
    return {
      testiAdd: {},
      testi: true
    };
  },
  methods: {
    add_testimonial: function() {
      this.testiAdd.access_token = localStorage.getItem("access_token");
      this.testiAdd.admin_id = localStorage.getItem("admin_id");
      axios({
        method: "POST",
        url: "admin/testimonials/new",
        data: this.testiAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Testimonials Added Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    },
    getsingleTestimonial() {
      axios({
        url:
          "/admin/testimonials/" +
          this.$route.params.testimonial_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.testiAdd = result.data.testimonial;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_testimonial: function() {
      this.testiAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url: "/admin/testimonials/update/" + this.$route.params.testimonial_id,
        data: this.testiAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Testimonials Updated Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          let errors = error.response.data.error;
          for (let error in errors) {
            this.$noty.error("Error: " + _.startCase(errors[error][0]));
          }
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.testimonial_id > 0) {
      this.testi = false;
      this.getsingleTestimonial();
    } else {
      this.testiAdd = {};
      this.testi = true;
    }
  }
};
</script>

<style lang="scss">
.new-create {
  padding-right: 20px;
  padding-left: 20px;
  .new-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .new-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
